import { takeLatest, all, call, put } from 'redux-saga/effects';

import { ERROR_LEVELS, SENTRY_APP } from '@user-portal/sentry-utils';

import { SolidMerchantDataResponse } from 'api/types/payment';
import api from 'api';

import { initSolidPayment, setSolidMerchantData, setIsMerchantLoading, solidValidate } from './actions';
import { notifyError } from '../notifications/actions';

import { INIT_SOLID_PAYMENT, SOLID_POST_INIT } from './actionTypes';

import sentry from 'services/Sentry/SentryInstance';

function* getSolidMerchantData({ payload }: ReturnType<typeof initSolidPayment>) {
    try {
        yield put(setIsMerchantLoading(true));
        const response: SolidMerchantDataResponse = yield call(api.payment.getSolidMerchantData, {
            payment_method: 1,
            country: payload.country,
            currency: payload.currency,
            price: payload.price,
            product_code: payload.productCode,
            product_type: payload.productCodeType,
            order_type: 'fee_charge',
            subscription_id: payload.subscriptionId,
        });

        yield put(setSolidMerchantData(response));
        yield put(setIsMerchantLoading(false));
    } catch (error: any) {
        sentry.logError(`solid_init_payment_error | ${error?.message}`, SENTRY_APP, ERROR_LEVELS.CRITICAL, {
            reason: 'solid_init_payment_error',
            details: error,
            externalId: payload?.subscriptionId,
            payload,
        });
        notifyError('initPayment error');
    }
}

function* handleSolidValidate({ payload }: ReturnType<typeof solidValidate>) {
    try {
        yield call(api.payment.solidPostInit, payload);
    } catch (error: any) {
        sentry.logError(`solid_post_init_error | ${error?.message}`, SENTRY_APP, ERROR_LEVELS.CRITICAL, {
            reason: 'solid_post_init_error',
            details: error,
            externalId: payload?.subscription_id,
            payload,
        });
        notifyError('postInit error');
    }
}

export default function* watchPayment() {
    yield all([takeLatest(INIT_SOLID_PAYMENT, getSolidMerchantData)]);
    yield all([takeLatest(SOLID_POST_INIT, handleSolidValidate)]);
}
